var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.178,
    y1: 0.146,
    x2: 1,
    y2: 1.273,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ec4a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d9a70"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_profile",
    transform: "translate(-1719 -31)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1719 31)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person_FILL0_wght400_GRAD0_opsz48",
    d: "M18.847,19.119a4.877,4.877,0,0,1-5.085-5.085A4.877,4.877,0,0,1,18.847,8.95a4.877,4.877,0,0,1,5.085,5.085,4.877,4.877,0,0,1-5.085,5.085ZM27.66,30H10.034A2.025,2.025,0,0,1,8,27.966V26.814a3.73,3.73,0,0,1,.644-2.2,4.135,4.135,0,0,1,1.661-1.39A25.479,25.479,0,0,1,14.661,21.7a17.608,17.608,0,0,1,4.186-.508,16.867,16.867,0,0,1,4.169.525,28.875,28.875,0,0,1,4.339,1.508,4.087,4.087,0,0,1,1.695,1.39,3.73,3.73,0,0,1,.644,2.2v1.153A2.025,2.025,0,0,1,27.66,30ZM10.034,27.966H27.66V26.814a1.857,1.857,0,0,0-.322-1.034,2.041,2.041,0,0,0-.8-.729,18,18,0,0,0-3.966-1.441,17.538,17.538,0,0,0-3.729-.39,18.015,18.015,0,0,0-3.763.39,17.217,17.217,0,0,0-3.966,1.441,2.04,2.04,0,0,0-1.085,1.763Zm8.813-10.881A2.956,2.956,0,0,0,21.9,14.035a3.051,3.051,0,1,0-6.1,0,2.956,2.956,0,0,0,3.051,3.051ZM18.847,14.035ZM18.847,27.966Z",
    transform: "translate(1720.152 31.051)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.38c3db4cf46834f97fdd112ab76eb8d7.svg";
export { ForwardRef as ReactComponent };